import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Index from "./pages/Index"; // управление коллекциями
import Gallery from "./pages/Gallery"; // главная галерея
import CollectionPage from "./pages/Collection"; // публичная страница коллекции
import Search from "./pages/Search";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import Category from "./pages/Category";
import Paths from "./pages/Paths";
import PublicPath from "./pages/PublicPath";

import { AuthProvider } from "./contexts/AuthContext";

import "./index.css";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Gallery />} />               {/* ✅ Галерея */}
            <Route path="/manage" element={<Index />} />           {/* ✅ Управление коллекциями */}
            <Route path="/auth" element={<Auth />} />
            <Route path="/search" element={<Search />} />
            <Route path="/paths" element={<Paths />} />
            <Route path="/paths/:id" element={<PublicPath />} />
            <Route path="/collection/:id" element={<CollectionPage />} />
            <Route path="/category/:slug" element={<Category />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
